import React, { useState } from 'react';
import Papa from 'papaparse';
import { importCSV } from '../services/api';

const Import = () => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      Papa.parse(selectedFile, {
        header: true,
        preview: 5,
        complete: (results) => {
          setPreview(results.data);
        },
      });
    }
  };

  const handleImport = async () => {
    if (!file) {
      setMessage({ type: 'error', text: 'Veuillez sélectionner un fichier CSV.' });
      return;
    }

    setLoading(true);
    setMessage({ type: '', text: '' });

    try {
      Papa.parse(file, {
        header: true,
        complete: async (results) => {
          try {
            const result = await importCSV(results.data);
            setMessage({
              type: 'success',
              text: `Import réussi: ${result.inserted || 0} agent(s) importé(s)`,
            });
            setFile(null);
            setPreview(null);
          } catch (error) {
            setMessage({
              type: 'error',
              text: error.response?.data?.message || 'Erreur lors de l\'import',
            });
          } finally {
            setLoading(false);
          }
        },
        error: (error) => {
          setMessage({ type: 'error', text: 'Erreur de parsing CSV: ' + error.message });
          setLoading(false);
        },
      });
    } catch (error) {
      setMessage({ type: 'error', text: 'Erreur lors de l\'import' });
      setLoading(false);
    }
  };

  return (
    <div className="p-8 bg-background min-h-screen">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-text mb-8 flex items-center">
          <i className="fas fa-file-import mr-3 text-primary"></i>
          Import CSV
        </h1>

        <div className="bg-cardBg rounded-lg shadow-lg p-8">
          <div className="mb-6">
            <label className="block text-sm font-medium text-text mb-2">
              <i className="fas fa-file-csv mr-2 text-primary"></i>Sélectionner un fichier CSV
            </label>
            <input
              type="file"
              accept=".csv"
              onChange={handleFileChange}
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary focus:border-primary outline-none"
            />
            {file && (
              <p className="mt-2 text-sm text-text-light">
                <i className="fas fa-check-circle text-green-500 mr-2"></i>
                Fichier sélectionné: {file.name}
              </p>
            )}
          </div>

          {preview && preview.length > 0 && (
            <div className="mb-6">
              <h3 className="text-lg font-semibold text-text mb-4">Aperçu (5 premières lignes)</h3>
              <div className="overflow-x-auto">
                <table className="w-full border-collapse border border-gray-300">
                  <thead>
                    <tr className="bg-primary text-white">
                      {Object.keys(preview[0]).map((key) => (
                        <th key={key} className="border border-gray-300 px-4 py-2 text-left">
                          {key}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {preview.map((row, idx) => (
                      <tr key={idx} className="hover:bg-gray-50">
                        {Object.values(row).map((value, i) => (
                          <td key={i} className="border border-gray-300 px-4 py-2 text-sm">
                            {value}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <h4 className="font-semibold text-blue-900 mb-2">
              <i className="fas fa-info-circle mr-2"></i>Format CSV attendu
            </h4>
            <p className="text-sm text-blue-800">
              Le fichier CSV doit contenir les colonnes suivantes (en-têtes) :
            </p>
            <ul className="list-disc list-inside text-sm text-blue-800 mt-2">
              <li>nom, prenom, sexe, date_naissance, lieu_naissance</li>
              <li>nationalite, telephone, email, adresse</li>
              <li>categorie, bureau, cellule, grade</li>
            </ul>
          </div>

          {message.text && (
            <div
              className={`mb-4 p-4 rounded-lg ${
                message.type === 'success'
                  ? 'bg-green-100 text-green-700 border border-green-400'
                  : 'bg-red-100 text-red-700 border border-red-400'
              }`}
            >
              <i
                className={`fas ${
                  message.type === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'
                } mr-2`}
              ></i>
              {message.text}
            </div>
          )}

          <div className="flex justify-end">
            <button
              onClick={handleImport}
              disabled={loading || !file}
              className="px-8 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary-dark transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <>
                  <i className="fas fa-spinner fa-spin mr-2"></i>Import en cours...
                </>
              ) : (
                <>
                  <i className="fas fa-upload mr-2"></i>Importer
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Import;

